var render = function render(){
  var _vm$config$general, _vm$config$general2, _vm$config$general3, _vm$config$general4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('transition', {
    attrs: {
      "name": _vm.$store.state.isLayoutSwitched ? 'slide-in-down' : 'slide-in-up'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$store.state.isBottomBarVisible,
      expression: "$store.state.isBottomBarVisible"
    }],
    staticClass: "bottom-bar"
  }, [_c('div', {
    staticClass: "bottom-bar__left"
  }, [_vm.$store.state.selector ? _c('a', {
    staticClass: "selector-btn touch",
    attrs: {
      "href": "http://localhost:9000",
      "dir": _vm.language.dir
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.config.labels.exploreCommunities[_vm.language.code] || _vm.config.labels.exploreCommunities["en"]))])]) : _vm._e(), (_vm$config$general = _vm.config.general) !== null && _vm$config$general !== void 0 && _vm$config$general.showHomeButton ? _c('button', {
    staticClass: "bottom-bar__home-button touch",
    on: {
      "click": _vm.navigateHome
    }
  }, [_c('div', {
    staticClass: "btn__icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5 64 488l0 24 24 0 400 0 24 0 0-24 0-234.5 24.5 20.8 31.1-36.6-264-224zM112 464l0-251.2L288 63.5 464 212.8 464 464l-80 0 0-168 0-24-24 0-144 0-24 0 0 24 0 168-80 0zm128 0l0-144 96 0 0 144-96 0z"
    }
  })])])]) : _vm._e(), _c('ButtonBack'), !_vm.$store.state.selector && (_vm$config$general2 = _vm.config.general) !== null && _vm$config$general2 !== void 0 && _vm$config$general2.showSensorealBranding ? _c('div', [_c('img', {
    staticClass: "bottom-bar__sensoreal-logo touch",
    attrs: {
      "src": "/assets/sensoreal.png"
    },
    on: {
      "click": function click($event) {
        return _vm.forceRefresh();
      }
    }
  })]) : _vm._e(), (_vm$config$general3 = _vm.config.general) !== null && _vm$config$general3 !== void 0 && _vm$config$general3.showLayoutSwitchToggle ? _c('div', {
    staticClass: "bottom-bar__layout-toggle"
  }, [_c('button', {
    staticClass: "touch",
    on: {
      "click": function click($event) {
        return _vm.$store.commit('SET_IS_LAYOUT_SWITCHED', !_vm.$store.state.isLayoutSwitched);
      }
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fas', 'sync']
    }
  })], 1)]) : _vm._e()], 1), _c('div', {
    staticClass: "bottom-bar__center"
  }, [_c('transition-group', {
    staticClass: "bottom-bar__nav-items",
    class: {
      'dir-rtl': _vm.language.dir === 'rtl'
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "afterEnter": _vm.afterEnter,
      "leave": _vm.leave
    }
  }, _vm._l(_vm.activeNavItems, function (item, index) {
    return _c('div', {
      key: item._id,
      staticClass: "bottom-bar__nav-item-wrapper",
      class: [{
        'bottom-bar__nav-item-wrapper--active': _vm.isNavItemActive(item)
      }, {
        'bottom-bar__nav-item-wrapper--last-item': item.isLiveSection
      }],
      attrs: {
        "data-index": index,
        "dir": _vm.language.dir
      }
    }, [_c('router-link', {
      staticClass: "bottom-bar__nav-button touch",
      class: [{
        'router-link-active': _vm.isNavItemActive(item)
      }, {
        'bottom-bar__nav-button--live': item.isLiveSection
      }],
      attrs: {
        "tag": "button",
        "to": _vm.getItemLink(item)
      },
      nativeOn: {
        "click": function click($event) {
          _vm.triggerMedia(item.label['en']);
          _vm.playClickSound();
          _vm.bus.$emit('navClick');
        }
      }
    }, [item.icon && item.icon[1] ? _c('div', {
      staticClass: "icon"
    }, [_c('fa', {
      attrs: {
        "icon": [_vm.config.iconSet, item.icon[1]]
      }
    })], 1) : _vm._e(), _c('span', {
      staticClass: "bottom-bar__nav-label",
      domProps: {
        "innerHTML": _vm._s(item.label[_vm.language.code] || item.label['en'])
      }
    })])], 1);
  }), 0)], 1), _c('div', {
    staticClass: "bottom-bar__right"
  }, [_c('div', {
    staticClass: "bottom-bar__nav-item-wrapper"
  }, [(_vm$config$general4 = _vm.config.general) !== null && _vm$config$general4 !== void 0 && _vm$config$general4.showFavourites ? _c('router-link', {
    staticClass: "bottom-bar__nav-button bottom-bar__nav-button--favourites",
    class: [{
      touch: _vm.favourites.length
    }, {
      'has-favourites': _vm.favourites.length
    }, {
      'is-square': !_vm.favouritesButtonLabel
    }],
    attrs: {
      "tag": "button",
      "to": _vm.viewFavouriteLink
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('fa', {
    attrs: {
      "icon": ['far', 'heart']
    }
  })], 1), _c('span', {
    staticClass: "bottom-bar__nav-label"
  }, [_vm._v(_vm._s(_vm.favouritesButtonLabel))])]) : _vm._e()], 1), _vm.languages.length > 1 ? _c('div', {
    staticClass: "bottom-bar__language-selector"
  }, _vm._l(_vm.languages, function (lang) {
    return _c('div', {
      key: lang.code,
      staticClass: "bottom-bar__language-selector-button touch",
      class: {
        'bottom-bar__language-selector-button--active': lang.code === _vm.language.code
      },
      on: {
        "click": function click($event) {
          return _vm.setLanguage(lang);
        }
      }
    }, [_c('div', [_vm._v("\n              " + _vm._s(lang.code) + "\n            ")])]);
  }), 0) : _vm._e()])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }